import * as api from '../../api/api-solicitud-descuento-modal';
import { 
    GET_CONFIG_FORM26,
    GET_DATOS_SOLICITUD
    
} from '../types';

export const configuracionFormAction26 = (query) => ({
    type: GET_CONFIG_FORM26,
    payload: api.getConfiguracionForm26(query)
});
export const obtenerDatosSolicitud = (query) => ({
    type: GET_DATOS_SOLICITUD,
    payload: api.getDatosSolicitud(query)
});
